module.exports = __webpack_public_path__ + "static/img/3.edf9ea5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/sp/3.png
// module id = Tenr
// module chunks = 0